export default __webpack_public_path__ + "public/assets/images/d4eead10096c32d756a15f48720ff07d.png";